export default function EmergencySection() {
  const handleCallClick = () => {
    window.location.href = 'tel:2245376610';
  };

  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/811abb3afcc10bb8fa667b8620fec2e4.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-black/40"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Unexpected<br />
            Home<br />
            Emergency?
          </h2>
          
          <p className="text-xl md:text-2xl text-white mb-12 leading-relaxed">
            Stop the panic. Get fast, reliable<br />
            help when you need it most, not<br />
            tomorrow.
          </p>

          <button
            onClick={handleCallClick}
            className="inline-flex flex-col items-center justify-center bg-blue-500 hover:bg-blue-600 text-white rounded-full px-12 py-6 transition-all duration-300 transform hover:scale-105 shadow-2xl cursor-pointer whitespace-nowrap"
          >
            <span className="text-lg font-semibold mb-1">Get Help</span>
            <span className="text-3xl font-bold tracking-wide">224 537 6610</span>
          </button>
        </div>
      </div>
    </section>
  );
}
